import { DraftsBlock } from '@/components/home/drafts/DraftsBlock';
import { Grid, Stack, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useOutletContext } from 'react-router-dom';
import React, { FC, ReactElement } from 'react';

interface OutletProps {
  letterDraftsCount?: number;
}

export const MobileDraftsBlock: FC = (): ReactElement => {
  const { letterDraftsCount } = useOutletContext<OutletProps>();

  return (
    <Grid container={true} direction={'column'} spacing={2}>
      <Grid item={true}>
        <Stack direction={'row'} spacing={1}>
          <Typography variant={'h2'} fontSize={'20px'} lineHeight={'24px'} fontWeight={500}>
            {'Черновики'}
          </Typography>
          {!isNaN(Number(letterDraftsCount)) && (
            <Typography
              variant={'h2'}
              fontSize={'20px'}
              lineHeight={'24px'}
              fontWeight={400}
              sx={{ color: (theme: Theme) => theme.colors.grayText }}>
              {letterDraftsCount}
            </Typography>
          )}
        </Stack>
      </Grid>
      <Grid item={true}>
        <DraftsBlock />
      </Grid>
    </Grid>
  );
};
